module.exports = __webpack_public_path__ + "static/img/enhanced.af9095b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enhanced.svg
// module id = 3hkA
// module chunks = 1